import Vue from "vue";
import Router from "vue-router";
import DashBoard from "@/view/dashBoard";
// import Home from "@/view/home";
// import AboutUs from "@/view/AboutUs";
// import products from "@/view/products";
// import ContactUs from "@/view/contactUs";

import Solvents from "@/view/products/Solvents"
import Coating from "@/view/products/Coating"
import Others from "@/view/products/Others"

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: "/", // 默认页面重定向到主页
      redirect: "/dashBoard",
    },
    {
      path: "/dashBoard",
      component: DashBoard,
      redirect: "/home",
      children: [
        {
          path: "/home",
          component: () => import("@/view/home"),
        },
        {
          path: "/aboutUs",
          component: () => import("@/view/AboutUs"),
        },
        {
          path: "/contactUs",
          component: () => import("@/view/contactUs"),
        },
        {
          path: "/news",
          component: () => import("@/view/News"),
        },

        {
          path: "/Products",
          component: () => import("@/view/products"),
          redirect: "/Solvents",
          children: [
            {
              path: "/Solvents",
              component: Solvents,
            },
            {
              path: "/Coating",
              component: Coating,
            },
            {
              path: "/Others",
              component: Others,
            },
          ],
        },
       
        // {
        //   path: "/Solvents",
        //   component: () => import("@/view/products/Solvents"),
        // },

        // {
        //   path: "/Acrylates",
        //   component: () => import("@/view/products/Acrylates"),
        // },

        // {
        //   path: "/PaintingCoatingAndInks",
        //   component: () => import("@/view/products/PaintingCoatingAndInks"),
        // },
      ],
    },
    {
      path: "*",
      component: DashBoard,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.path === from.path) {
    next(false); // 停止导航，防止重复路由
  } else {
    next(); // 继续导航
  }
});

export default router;
